import * as React from 'react'

import type { EmailCampaign, EmailCampaignSchedule } from 'types/campaign'

type Props = {
  campaign: Pick<EmailCampaign, 'name' | 'type'>
  // null when the campaign has no stored timezone
  rescheduleData: EmailCampaignSchedule | null | undefined
  timezoneOffset: string | undefined
}

/**
 * Body of the Cancel scheduled email dialog. Names the send time when the
 * campaign has one to show, and only the campaign otherwise.
 */
const CancelScheduleMessage = ({
  campaign,
  rescheduleData,
  timezoneOffset,
}: Props): React.ReactElement => (
  <span>
    {rescheduleData ? (
      <>
        Are you sure you want to cancel the scheduled time of{' '}
        {rescheduleData.date?.label} at {rescheduleData.time?.label} (GMT
        {timezoneOffset}) for “
      </>
    ) : (
      <>Are you sure you want to cancel the schedule for “</>
    )}
    <span translate={campaign.name ? 'no' : undefined}>
      {campaign.name || `Untitled ${campaign.type}`}
    </span>
    <span>”?</span>
  </span>
)

export default CancelScheduleMessage
